// extracted by mini-css-extract-plugin
module.exports = {"sliderBlock":"ipCIf","col":"XV9Ay","mostAnalytics":"Pg3av","readMore":"gTwMp","readMoreLink":"YEh80","readMoreLinkText":"OOsFx"};